var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);} /* eslint-disable max-lines */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {

  useLoaderData,

  unstable_useBlocker as useBlocker,
  Link,

  useFetcher } from
'react-router-dom';
import { InformationCircleIcon } from '@heroicons/react/20/solid';

import { useForm } from 'react-hook-form';
import { useSetRecoilState } from 'recoil';
import { Translate } from "../../../../I18N";

import { ConfirmNavigationModal } from "../../../Components/Forms";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, ToggleButton } from "../../../Components/UI";
import * as translationsAPI from "../../../api/translations";
import * as settingsAPI from "../../../api/settings";
import { notificationAtom } from "../../../atoms";
import { availableLanguages } from "../../../../../shared/languagesList";

import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { TranslationsTables } from "./components/TableComponents";

const editTranslationsLoader =
(headers) =>
async ({ params }) => {
  const translations = await translationsAPI.get(headers, params);
  const settings = await settingsAPI.get(headers);
  return { translations, settings };
};

const editTranslationsAction =
() =>
async ({ params, request }) => {
  const formData = await request.formData();
  const formIntent = formData.get('intent');
  const { context } = params;

  if (formIntent === 'form-submit' && context) {
    const formValues = formData.get('data');
    return translationsAPI.post(JSON.parse(formValues), context);
  }

  if (formIntent === 'file-upload') {
    const file = formData.get('data');
    return translationsAPI.importTranslations(file, 'System');
  }

  return null;
};







const prepareValuesToSave = (
data,
currentTranslations) =>

data.map((language, index) => {
  const values = Object.values(language.values).reduce(
    (result, value) => _objectSpread(_objectSpread({},
    result), {}, {
      [value.key]: value.value }),

    {}
  );
  return _objectSpread(_objectSpread({},
  currentTranslations[index]), {}, {
    contexts: [_objectSpread(_objectSpread({}, currentTranslations[index].contexts[0]), {}, { values })] });

});

const composeTableValues = (formValues, termIndex) =>
formValues.map((language, languageIndex) => {var _availableLanguages$f, _formValues$languageI;
  const languaLabel = (_availableLanguages$f = availableLanguages.find(
    (availableLanguage) => availableLanguage.key === language.locale
  )) === null || _availableLanguages$f === void 0 ? void 0 : _availableLanguages$f.localized_label;
  return {
    language: languaLabel,
    translationStatus: {
      languageKey: language.locale,
      status: ((_formValues$languageI = formValues[languageIndex].values[termIndex]) === null || _formValues$languageI === void 0 ? void 0 : _formValues$languageI.translationStatus) || 'untranslated'
    },
    fieldKey: `formValues.${languageIndex}.values.${termIndex}.value`
  };
});

const getTraslationStatus = (
defaultLanguageValues,
evaluatedTerm,
currentLanguageKey,
defaultLanguageKey) =>
{
  const isUntranslated =
  defaultLanguageValues[evaluatedTerm.key] === evaluatedTerm.value &&
  defaultLanguageKey !== currentLanguageKey;
  const isDefaultLanguage = defaultLanguageKey === currentLanguageKey;

  if (isUntranslated) return 'untranslated';
  if (isDefaultLanguage) return 'defaultLanguage';
  return 'translated';
};

const prepareFormValues = (translations, defaultLanguageKey) => {var _translations$find;
  const defaultLanguageValues = (_translations$find = translations.find(
    (language) => language.locale === defaultLanguageKey
  )) === null || _translations$find === void 0 ? void 0 : _translations$find.contexts[0].values;

  return translations.map((language) => {var _language$_id;
    const values = Object.entries(language.contexts[0].values || {}).
    sort().
    reduce(
      (result, [key, value], index) => _objectSpread(_objectSpread({},
      result), {}, {
        [index]: {
          key,
          value,
          translationStatus: getTraslationStatus(
            defaultLanguageValues || {},
            { key, value },
            language.locale,
            defaultLanguageKey
          )
        } }),

      {}
    );
    return { _id: (_language$_id = language._id) === null || _language$_id === void 0 ? void 0 : _language$_id.toString(), locale: language.locale, values };
  });
};

const getContextInfo = (translations) => {
  const contextTerms = Object.keys(translations[0].contexts[0].values || {}).sort();
  const { label: contextLabel, id: contextId } = translations[0].contexts[0];
  return { contextTerms, contextLabel, contextId };
};

const filterTableValues = (values) =>
values.filter((value) => value.translationStatus.status !== 'translated');

const calculateTableData = (terms, formValues, hideTranslated) =>
terms.
map((term, index) => {
  let values = composeTableValues(formValues, index);
  if (hideTranslated) values = filterTableValues(values);
  if (values.length === 1 && hideTranslated) return undefined;
  return { [term]: values };
}).
filter((v) => v);

// eslint-disable-next-line max-statements
const EditTranslations = () => {var _settings$languages;
  const { translations, settings } = useLoaderData();




  const [hideTranslated, setHideTranslated] = useState(false);
  const fetcher = useFetcher();
  const setNotifications = useSetRecoilState(notificationAtom);
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);

  const isSubmitting = fetcher.state === 'submitting';
  const { contextTerms, contextLabel, contextId } = getContextInfo(translations);
  const defaultLanguage = settings === null || settings === void 0 ? void 0 : (_settings$languages = settings.languages) === null || _settings$languages === void 0 ? void 0 : _settings$languages.find((language) => language.default);
  const formValues = prepareFormValues(translations, (defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.key) || 'en');

  const {
    register,
    handleSubmit,
    setValue,
    getFieldState,
    reset,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { isDirty, errors, isSubmitting: formIsSubmitting }
  } = useForm({
    defaultValues: { formValues },
    mode: 'onSubmit'
  });

  const blocker = useBlocker(isDirty && !formIsSubmitting);

  useMemo(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true);
    }
  }, [blocker, setShowModal]);

  useEffect(() => {var _fetcher$formData, _fetcher$formData2, _fetcher$data$json, _fetcher$data$json2;
    switch (true) {
      case ((_fetcher$formData = fetcher.formData) === null || _fetcher$formData === void 0 ? void 0 : _fetcher$formData.get('intent')) === 'form-submit' && Array.isArray(fetcher.data):
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Translations saved")
        });
        break;

      case ((_fetcher$formData2 = fetcher.formData) === null || _fetcher$formData2 === void 0 ? void 0 : _fetcher$formData2.get('intent')) === 'file-upload' && Array.isArray(fetcher.data):
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Translations imported.")
        });
        break;

      case fetcher.data instanceof FetchResponseError:
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
          details: (_fetcher$data$json = fetcher.data.json) !== null && _fetcher$data$json !== void 0 && _fetcher$data$json.prettyMessage ? (_fetcher$data$json2 = fetcher.data.json) === null || _fetcher$data$json2 === void 0 ? void 0 : _fetcher$data$json2.prettyMessage : undefined
        });
        break;

      default:
        break;
    }
  }, [fetcher.data, fetcher.formData, setNotifications]);

  const tablesData = calculateTableData(contextTerms, formValues, hideTranslated);

  const formSubmit = async (data) => {
    const formData = new FormData();
    const values = prepareValuesToSave(data.formValues, translations);
    formData.set('intent', 'form-submit');
    formData.set('data', JSON.stringify(values));
    fetcher.submit(formData, { method: 'post' });
    reset({}, { keepValues: true });
  };

  const importFile = async (event) => {var _event$target$files;
    const file = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];

    if (file) {
      const formData = new FormData();
      formData.set('intent', 'file-upload');
      formData.set('data', file);
      fetcher.submit(formData, { method: 'post', encType: 'multipart/form-data' });
      reset({}, { keepValues: true });
    }
  };

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-translations-edit" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Translations', '/settings/translations']]),
      title: contextLabel,
      contextId: contextId }
    ), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "px-5 pt-5" }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, { className: "px-5 pt-5", onToggle: () => setHideTranslated(!hideTranslated) }, void 0, /*#__PURE__*/
    _jsx("div", { className: "pl-1 text-sm text-gray-700" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Untranslated Terms")
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-grow" }, void 0,
    tablesData.length ? /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(formSubmit), id: "edit-translations" }, void 0, /*#__PURE__*/
    _jsx(TranslationsTables, {
      tablesData: tablesData,
      submitting: isSubmitting,
      register: register,
      setValue: setValue,
      getFieldState: getFieldState }
    )
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex items-center gap-2 p-4 border rounded-md border-gray-50 bg-primary-50" }, void 0, /*#__PURE__*/
    _jsx(InformationCircleIcon, { className: "w-10 text-primary-800" }), /*#__PURE__*/
    _jsx("span", { className: "text-primary-800" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "There are no untranslated terms")
    )
    )

    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex-1" }, void 0,
    contextId === 'System' && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      type: "button",
      disabled: isSubmitting,
      onClick: () => {var _fileInputRef$current;return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();} }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Import")
    ), /*#__PURE__*/
    React.createElement("input", {
      ref: fileInputRef,
      type: "file",
      accept: "text/csv",
      className: "hidden",
      onChange: importFile }
    )
    )

    ), /*#__PURE__*/
    _jsx(Link, { to: "/settings/translations" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", type: "button", disabled: isSubmitting }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    ), /*#__PURE__*/
    _jsx(Button, { type: "submit", disabled: isSubmitting, form: "edit-translations" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    ),

    showModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowModal, onConfirm: blocker.proceed })

    ));

};

export { EditTranslations, editTranslationsLoader, editTranslationsAction };